import React, { JSX } from 'react';

import { SimpleMultiSelect } from '~/src/dash/components/dropdowns/SimpleMultiSelect';
import { Div, usePublicaTranslation } from '~/src/dash/publicaUI';
import { IMenuList } from '~/src/dash/types/menuList';

interface IProps {
  // simple multi select
  columnsList: IMenuList;
  columnsHandleOnChangeOption: (keys: string[], _id?: string) => void;
  columnsHandleOnAccept: (keys: string[]) => void;
  preselectedColumnKeys?: string[];
  resetActiveColumnKeys?: string[];
  disableSort?: boolean;
}

export const ColumnSelector = ({
  // simple multi select
  columnsList,
  columnsHandleOnChangeOption,
  columnsHandleOnAccept,
  preselectedColumnKeys,
  resetActiveColumnKeys,
  disableSort,
}: IProps): JSX.Element => {
  const { t } = usePublicaTranslation();
  return (
    <Div>
      {/* ACTIVE COLUMNS */}
      <SimpleMultiSelect
        buttonStyle={{ padding: '2px 4px 2px 12px' }}
        resetKeys={resetActiveColumnKeys}
        preselectedKeys={preselectedColumnKeys || []}
        label={t('ActiveColumns')}
        list={columnsList}
        handleOnChangeOption={columnsHandleOnChangeOption}
        handleOnAccept={columnsHandleOnAccept}
        singularLabel={t('ActiveColumn')}
        iconPath='/assets/shared/svg/ColumnEdit.svg'
        disableSort={disableSort}
      />
    </Div>
  );
};
